import React from 'react'
import {connect} from 'react-redux'

@connect(({emailDocument}) => ({emailDocument}))
export default class EmailDocument extends React.Component {
    constructor(props) {
		super(props)
		const {emailDocument} = props
		if (emailDocument.id) {
            window.open(`/localdocument?localId=${emailDocument.id}`, '_self')
		}
    }
}



// WEBPACK FOOTER //
// ./components/emailDocument/index.jsx